export const app = angular.module('deliveryCreate.app', [
    'ngMaterial',
    'Authentication',
    'ui.router',
    'chart.js',
    'ngAnimate',
    'ngMessages',
    'ngCookies',
    'pascalprecht.translate',
    'md.data.table',
    //'AdalAngular',
    'angulartics',
	'angulartics.google.analytics',
	'ui.mask'
]);

import './core/msal/bootstrap';
import './core/bootstrap';
import './features/bootstrap';

import {apiInterceptor} from './core/apiInterceptor';
import {httpAuthInterceptor} from './core/httpAuthInterceptor';
import {httpMethodInterceptor} from './core/httpMethodInterceptor';
import {IApiBaseUrlFactory} from './core/iApiBaseUrlFactory';
import { IStateChangeService } from './core/stateChangeService';


app.config(
    [ 
        '$urlRouterProvider',
        ($urlRouterProvider: ng.ui.IUrlRouterProvider) => {
            $urlRouterProvider.otherwise('/');
        }
    ]);

app.config(['$locationProvider', function ($locationProvider) {
    $locationProvider.hashPrefix('');
}]);

app.config(
    [
        '$httpProvider', 
        ($httpProvider: ng.IHttpProvider) => {
            $httpProvider.interceptors.push(apiInterceptor);
            $httpProvider.interceptors.push(httpAuthInterceptor);
            $httpProvider.interceptors.push(httpMethodInterceptor);
            $httpProvider.defaults.withCredentials = false;
        }
    ]);

app.config(
    [
        '$mdThemingProvider',
        ($mdThemingProvider: ng.material.IThemingProvider) => {
            $mdThemingProvider.theme('default')
                .primaryPalette('green', { 'default': '600' })
                .accentPalette('amber')
                .backgroundPalette('grey', { 'hue-1': '50' });
        }
    ]);

app.run(
    [
        '$rootScope',
        ($rootScope) => {
            $rootScope.isBootstrapping = true;
        }
    ]);

app.run(
    [
        '$location', 'ApiBaseUrlFactory',
        ($location: ng.ILocationService, apiBaseUrl: IApiBaseUrlFactory) => {
            apiBaseUrl.set($location.host());
        }
    ]);

app.run(
    [
        'ApiGatewayAuthenticationService',
        (apiGatewayAuthenticationService: Authentication.ApiGatewayAuthenticationService) => {
            apiGatewayAuthenticationService.resumeSession();
        }
    ]);

app.run([
    'StateChangeService',
    (stateChangeService: IStateChangeService) => {
        stateChangeService.initialize();
    }
]);

app.config([
    '$compileProvider',
    $compileProvider => {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|blob):/);
    }
]);

app.config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(false);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/app.module.ts
 **/